module.exports = __webpack_public_path__ + "media/gravel.d779aab3.svg";